import {
  Box,
  Fab,
  Theme,
  useMediaQuery,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LatLngBoundsExpression, Map } from "leaflet";
import React, { useEffect, useRef, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import Controls from "./Controls";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PlaceIcon from "@material-ui/icons/Place";
import { useTranslation } from "react-i18next";

const createStopMarker = (color?: string) => {
  return `
    <svg width="27" height="54" viewBox="0 0 27 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8.33398" y="37" width="10" height="10" rx="5" fill="#202124" fill-opacity="0.16"/>
      <g filter="url(#filter0_d)">
        <rect x="9.33398" y="38" width="8" height="8" rx="4" fill="#202124"/>
        <rect x="9.83398" y="38.5" width="7" height="7" rx="3.5" stroke="white"/>
      </g>
      <mask id="path-4-inside-1" fill="white">
        <path d="M13.334 0C6.14684 0 0.333984 5.81286 0.333984 13C0.333984 20.7443 8.54256 31.4229 11.9226 35.49C12.6654 36.3814 14.0211 36.3814 14.764 35.49C18.1254 31.4229 26.334 20.7443 26.334 13C26.334 5.81286 20.5211 0 13.334 0Z"/>
      </mask>
      <path d="M13.334 0C6.14684 0 0.333984 5.81286 0.333984 13C0.333984 20.7443 8.54256 31.4229 11.9226 35.49C12.6654 36.3814 14.0211 36.3814 14.764 35.49C18.1254 31.4229 26.334 20.7443 26.334 13C26.334 5.81286 20.5211 0 13.334 0Z" fill="#202124"/>
      <path d="M11.9226 35.49L11.1535 36.1291L11.1543 36.1302L11.9226 35.49ZM14.764 35.49L15.5322 36.1302L15.5348 36.1271L14.764 35.49ZM13.334 -1C5.59456 -1 -0.666016 5.26057 -0.666016 13H1.33398C1.33398 6.36514 6.69913 1 13.334 1V-1ZM-0.666016 13C-0.666016 17.1618 1.51445 21.9686 4.00209 26.1364C6.51417 30.3452 9.44752 34.0764 11.1535 36.1291L12.6916 34.8508C11.0176 32.8365 8.15665 29.1948 5.71945 25.1114C3.2578 20.9871 1.33398 16.5825 1.33398 13H-0.666016ZM11.1543 36.1302C12.297 37.5014 14.3896 37.5014 15.5322 36.1302L13.9958 34.8498C13.6527 35.2615 13.0338 35.2615 12.6908 34.8498L11.1543 36.1302ZM15.5348 36.1271C17.2303 34.0756 20.1588 30.3447 22.6684 26.1361C25.1536 21.9685 27.334 17.1617 27.334 13H25.334C25.334 16.5826 23.4101 20.9872 20.9506 25.1118C18.5156 29.1953 15.6591 32.8373 13.9932 34.8529L15.5348 36.1271ZM27.334 13C27.334 5.26057 21.0734 -1 13.334 -1V1C19.9688 1 25.334 6.36514 25.334 13H27.334Z" fill="white" mask="url(#path-4-inside-1)"/>
      <path d="M8.33398 13C8.33398 10.2386 10.5726 8 13.334 8C16.0954 8 18.334 10.2386 18.334 13C18.334 15.7614 16.0954 18 13.334 18C10.5726 18 8.33398 15.7614 8.33398 13Z" fill="white"/>
      <path d="M12.5003 16.3333V13.8333H14.167V16.3333H16.2503V13H17.5003L13.3337 9.25L9.16699 13H10.417V16.3333H12.5003Z" fill="white"/>
      <defs>
        <filter id="filter0_d" x="1.33398" y="30" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="4"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>`;
};

const createDriverMarker = () => {
  return `
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="14" cy="14" r="12" fill="#1329FE"/>
  <circle cx="14" cy="14" r="13.5" stroke="#1329FE"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3333 11.3333H19.3333L21.3333 14V17.3333H20C20 18.44 19.1066 19.3333 18 19.3333C16.8933 19.3333 16 18.44 16 17.3333H12C12 18.44 11.1066 19.3333 9.99996 19.3333C8.89329 19.3333 7.99996 18.44 7.99996 17.3333H6.66663V10C6.66663 9.26667 7.26663 8.66667 7.99996 8.66667H17.3333V11.3333ZM9.33329 17.3333C9.33329 17.7 9.63329 18 9.99996 18C10.3666 18 10.6666 17.7 10.6666 17.3333C10.6666 16.9667 10.3666 16.6667 9.99996 16.6667C9.63329 16.6667 9.33329 16.9667 9.33329 17.3333ZM19 12.3333L20.3066 14H17.3333V12.3333H19ZM17.3333 17.3333C17.3333 17.7 17.6333 18 18 18C18.3666 18 18.6666 17.7 18.6666 17.3333C18.6666 16.9667 18.3666 16.6667 18 16.6667C17.6333 16.6667 17.3333 16.9667 17.3333 17.3333Z" fill="white"/>
  </svg>
  `;
};

const getMarker = (type: string, color?: string) => {
  let marker;

  switch (type) {
    case "driver":
      marker = `
    <img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
      createDriverMarker()
    )}" />
    `;
      break;
    case "stop":
    default:
      marker = `
          <img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
            createStopMarker(color)
          )}" />
          `;
  }

  return marker;
};

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    height: "100%",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 120
    }
  },
  list: {
    padding: 0,
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 120,
    backgroundColor: "#fff"
  },
  listItem: {
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1, 3)
    }
  },
  btnWrapper: {
    position: "absolute",
    zIndex: 120,
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(8px)",
    "& button": {
      height: 42,
      backgroundColor: "#fff",
      color: theme.palette.primary.main,
      border: "1px solid #ddd"
    }
  }
}));

export default function MapWrapper({
  toggleMap,
  data,
  postalCode,
  dataLoaded,
  postalAvailable,
  setTooltipOpen
}: {
  toggleMap: () => void;
  data: any;
  postalCode: string | undefined;
  dataLoaded: boolean;
  postalAvailable: boolean | undefined;
  setTooltipOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const mapRef = useRef<Map>();

  const [mapLoaded, setMapLoaded] = useState<boolean>(false);

  const screenSm: boolean = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down("md")
  );

  const classes = useStyles();

  const { t } = useTranslation();

  useEffect(() => {
    if (mapRef.current) {
      const minZoom = mapRef.current.getBoundsZoom(
        [
          [-90, -180],
          [90, 180]
        ],
        true
      );
      mapRef.current.setMinZoom(minZoom);
    }
  }, [mapRef]);

  const boundsSet = useRef(false);

  useEffect(() => {
    // get coordinates array
    if (
      data &&
      !boundsSet.current &&
      data.stop_address?.lat &&
      data.stop_address?.lng
    ) {
      const bounds = [[data.stop_address?.lat, data.stop_address?.lng]];
      if (data.driver_location?.lat && data.driver_location?.lng) {
        bounds.unshift([data.driver_location.lat, data.driver_location.lng]);
      }

      try {
        mapRef.current &&
          mapRef.current.fitBounds(bounds as LatLngBoundsExpression, {
            paddingBottomRight: [30, 30],
            paddingTopLeft: [30, 30],
            duration: 1
          });

        // boundsSet.current = true;
      } catch (e) {
        console.log(e);
      }
    }
  }, [
    data.driver_location?.lat,
    data.driver_location?.lng,
    data.stop_address?.lat,
    data.stop_address?.lng,
    mapLoaded
  ]);
  // console.log(postal_code);

  return (
    <div className={classes.root}>
      {!postalCode && postalAvailable && (
        <div className={classes.btnWrapper}>
          <Button
            color="inherit"
            variant="contained"
            disableElevation
            onClick={e => {
              e.stopPropagation();
              setTooltipOpen(true);
            }}
          >
            {t("See more details")}
          </Button>
        </div>
      )}
      {screenSm && (
        <>
          <Fab
            sx={{
              position: "fixed",
              left: 24,
              top: 32,
              padding: 1.5,
              width: 48,
              height: 48,
              boxShadow: 3,
              backgroundColor: "#ffffff",
              color: "#5F6368",
              zIndex: 10
            }}
            onClick={toggleMap}
          >
            <ArrowBackIcon />
          </Fab>
          <List className={classes.list}>
            {data.driver && (
              <>
                <ListItem className={classes.listItem}>
                  <ListItemIcon>
                    <LocalShippingIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Driver")}
                    secondary={
                      data.driver.first_name + " " + data.driver.last_name
                    }
                  />
                </ListItem>
                <Divider />
              </>
            )}
            {data.stop_address?.street && (
              <>
                <ListItem className={classes.listItem}>
                  <ListItemIcon>
                    <PlaceIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Destination")}
                    secondary={`${data.stop_address.street}${
                      data.stop_address.postal_code
                        ? `, ${data.stop_address.postal_code}`
                        : ""
                    }${
                      data.stop_address.city
                        ? `, ${data.stop_address.city}`
                        : ""
                    }`}
                  />
                </ListItem>
              </>
            )}
          </List>
        </>
      )}

      <MapContainer
        center={
          dataLoaded
            ? [
                data.stop_address?.lat || 51.9244,
                data.stop_address?.lng || 4.4777
              ]
            : undefined
        }
        zoom={18}
        maxBounds={[
          [-90, -Infinity],
          [90, Infinity]
        ]}
        maxBoundsViscosity={1}
        maxZoom={18}
        zoomControl={false}
        whenCreated={mapInstance => {
          mapRef.current = mapInstance;
          setMapLoaded(true);
        }}
      >
        {data.stop_address && (
          <>
            {!["skipped", "finished"].includes(data.stop_status) &&
              data.driver_location && (
                <Marker
                  position={[
                    data.driver_location.lat,
                    data.driver_location.lng
                  ]}
                  icon={window.L.divIcon({
                    iconSize: [32, 32],
                    iconAnchor: [16, 16],
                    html: `<div class="marker-box">
                          ${getMarker("driver")}
                        </div>`
                  })}
                />
              )}

            <Marker
              position={[data.stop_address.lat, data.stop_address.lng]}
              icon={window.L.divIcon({
                iconSize: [26, 47],
                iconAnchor: [13, 47],
                html: `
                      <div class="marker-box">
                        ${getMarker("stop", "#202124")}
                      </div>`
              })}
            />
          </>
        )}
        <TileLayer
          url={`https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709`}
        />
      </MapContainer>

      {!screenSm && <Controls mapRef={mapRef} />}
    </div>
  );
}
